import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { TextLink } from 'baby-design'
import { giftGiverFaqPath } from 'lib/urls'
import { onContactUsClick } from 'shared/Footer/constants'
import styles from './MicroNavBar.styles.scss'

const MobileSeparatorIcon = () => (
  <svg
    className={styles.mobile_separator}
    fill="none"
    height="14"
    viewBox="0 0 2 14"
    width="2"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1L1 13"
      stroke="#252324"
      strokeLinecap="round"
      strokeWidth="0.8"
    />
  </svg>
)

const MicroNavBar: React.FC = () => (
  <div className={styles.MicroNavBar} data-testid="MicroNavBar">
    <h6 className={styles.slogan}>We take care of growing families.</h6>
    <div className={styles.help_links}>
      <TextLink
        data-testid="help_center_link"
        href={giftGiverFaqPath}
        innerContentClassName={styles.help_link}
        rel="noopener noreferrer"
        size="xs"
        target="_blank"
      >
        Help center
      </TextLink>
      <MobileSeparatorIcon />
      <TextLink
        data-testid="chat_with_us_link"
        innerContentClassName={styles.help_link}
        size="xs"
        onClick={onContactUsClick}
      >
        Chat with us
      </TextLink>
    </div>
  </div>
)

export default MicroNavBar
